var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('worklist',{ref:"worklist",staticStyle:{"margin-left":"15px","margin-right":"15px"},on:{"select_task":_vm.show_task,"refresh":_vm.refresh_worklist}}),_c('task-viewer',{ref:"task_viewer",staticStyle:{"margin-left":"15px","margin-right":"15px"},on:{"submitted":_vm.submitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }